
























































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import MyConfig from "@/config";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  apiserver: string = MyConfig.casapi;

  headers: any = {
    Authorization: window.localStorage.getItem("token")
  };

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("oplatformapps/modifyheadimage", {
              appid: this.appid,
              head_img_media_id: fieldValues.head_img_media_id
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  mounted() {
    // nothing
  }

  handleUploaded(e: any) {
    // console.log(e);
    if (e.file && e.file.status === "done") {
      const { field } = e.file.response.Data;
      const mediaId = e.file.response.Data.media_id;

      this.form.setFieldsValue({
        [`${field}`]: mediaId
      });
    }
  }
}
